// The Journal is shown only where the clinic has turned its AI companion on
// (`organization.features.journalCompanion`), the same switch the server
// enforces (blhWebServer src/domain/journal/journalCompanion.js): what a
// patient writes there is answered by a language model, and until the journal
// is rebuilt to blhWebServer ADR 0012 (README.md here) only a test clinic shows
// it.
//
// One definition: the menu, the home page's quick link and the page itself all
// ask this.

export function isJournalOn(state) {
  return state?.organization?.features?.journalCompanion === true;
}
